/* eslint-disable max-len */
import React from 'react';

export default function EventIcon() {
  return (
    <svg width="56" height="52" fill="none" viewBox="0 0 56 52">
      <path
        fill="url(#paint0_linear_10353_4636)"
        d="M48.76 3.097H6.291c-1.192 0-2.16.968-2.16 2.16V49.84c0 1.193.968 2.16 2.16 2.16H48.76c1.193 0 2.161-.967 2.161-2.16V5.257c0-1.192-.968-2.16-2.16-2.16z"
      />
      <path
        fill="url(#paint1_linear_10353_4636)"
        d="M48.759 52H6.293a2.16 2.16 0 01-2.161-2.16V26.431H50.92V49.84A2.16 2.16 0 0148.759 52z"
      />
      <path
        fill="url(#paint2_linear_10353_4636)"
        d="M48.759 52H6.293a2.16 2.16 0 01-2.161-2.16v-4.538H50.92v4.537A2.16 2.16 0 0148.759 52z"
      />
      <path
        fill="url(#paint3_linear_10353_4636)"
        d="M52.89 46.742H2.162A2.16 2.16 0 01.055 44.1l4.077-17.812H50.92L54.996 44.1a2.16 2.16 0 01-2.106 2.642z"
      />
      <path
        fill="url(#paint4_linear_10353_4636)"
        d="M52.89 46.742H2.162A2.16 2.16 0 01.055 44.1l4.077-17.812H50.92L54.996 44.1a2.16 2.16 0 01-2.106 2.642z"
      />
      <path
        fill="url(#paint5_linear_10353_4636)"
        d="M52.89 46.742a2.16 2.16 0 002.106-2.642L50.92 26.288H4.132l20.454 20.454H52.89z"
      />
      <path
        fill="url(#paint6_linear_10353_4636)"
        d="M50.92 46.742H4.132v.073L9.318 52h39.441a2.16 2.16 0 002.16-2.16v-3.098z"
      />
      <path
        fill="#fff"
        d="M16.358 30.574v-9.116c0-2.401.637-4.166 1.911-5.294 1.274-1.128 2.976-1.692 5.106-1.692s3.838.564 5.122 1.692c1.284 1.128 1.927 2.892 1.927 5.294v9.116c0 2.402-.643 4.166-1.927 5.294-1.284 1.128-2.992 1.692-5.122 1.692s-3.832-.564-5.106-1.692c-1.274-1.128-1.91-2.892-1.91-5.294zm3.32 0c0 2.694 1.233 4.041 3.697 4.041 1.19 0 2.11-.334 2.757-1.003.647-.668.971-1.68.971-3.038v-9.116c0-1.357-.324-2.37-.97-3.039-.648-.668-1.567-1.002-2.758-1.002-2.464 0-3.696 1.347-3.696 4.041v9.116zM32.46 19.203c0-.543.219-.971.657-1.285l3.259-3.132c.229-.23.511-.345.845-.345.376 0 .715.1 1.018.297.303.2.455.466.455.8v20.737c0 .334-.168.6-.502.799-.334.199-.72.298-1.159.298-.46 0-.851-.1-1.174-.298-.324-.198-.486-.465-.486-.799V18.858l-1.096 1.378c-.21.21-.439.313-.69.313-.313 0-.58-.14-.798-.422a1.471 1.471 0 01-.33-.924z"
      />
      <path
        fill="url(#paint7_linear_10353_4636)"
        d="M27.102 26.288v4.285c0 1.359-.322 2.371-.97 3.04-.647.668-1.566 1.002-2.756 1.002-2.465 0-3.698-1.348-3.698-4.042v-4.285h-3.32v4.285c0 2.403.637 4.168 1.912 5.294 1.273 1.128 2.976 1.693 5.106 1.693 2.129 0 3.837-.565 5.12-1.693 1.286-1.126 1.928-2.89 1.928-5.293v-4.286h-3.322z"
      />
      <path
        fill="url(#paint8_linear_10353_4636)"
        d="M35.373 26.288v9.987c0 .334.162.6.486.8.322.198.714.296 1.174.296.439 0 .825-.098 1.16-.297.333-.199.5-.465.5-.8v-9.986h-3.32z"
      />
      <path
        fill="url(#paint9_linear_10353_4636)"
        d="M54.997 44.1L50.92 26.287V5.258c0-1.193-.968-2.161-2.16-2.161h-1.023c1.193 0 2.161.968 2.161 2.16v21.031l4.077 17.811a2.16 2.16 0 01-2.106 2.643h1.022a2.16 2.16 0 002.106-2.643z"
      />
      <path
        fill="url(#paint10_linear_10353_4636)"
        d="M18.372 6.946a2.011 2.011 0 01-.641-1.473V3.097h4.033l3.294 3.294a5.599 5.599 0 011.64 3.958c0 1.088-.837 2.024-1.924 2.073a2.012 2.012 0 01-1.565-.64l-4.837-4.836z"
      />
      <path
        fill="url(#paint11_linear_10353_4636)"
        d="M19.747 7.49a2.017 2.017 0 01-2.016-2.016V2.017a2.017 2.017 0 014.033 0v3.457a2.017 2.017 0 01-2.017 2.016z"
      />
      <path
        fill="url(#paint12_linear_10353_4636)"
        d="M19.747 0v7.49a2.017 2.017 0 002.017-2.016V2.017A2.017 2.017 0 0019.747 0z"
      />
      <path
        fill="url(#paint13_linear_10353_4636)"
        d="M33.028 6.946a2.011 2.011 0 01-.64-1.473V3.097h4.032l3.294 3.294a5.599 5.599 0 011.64 3.958c0 1.088-.837 2.024-1.923 2.073a2.012 2.012 0 01-1.566-.64l-4.837-4.836z"
      />
      <path
        fill="url(#paint14_linear_10353_4636)"
        d="M34.404 7.49a2.017 2.017 0 01-2.017-2.016V2.017a2.017 2.017 0 014.034 0v3.457a2.017 2.017 0 01-2.017 2.016z"
      />
      <path
        fill="url(#paint15_linear_10353_4636)"
        d="M34.404 0v7.49a2.017 2.017 0 002.017-2.016V2.017A2.017 2.017 0 0034.404 0z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10353_4636"
          x1="19.385"
          x2="31.851"
          y1="9.455"
          y2="37.157"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A6F9" />
          <stop offset="1" stopColor="#0071E2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10353_4636"
          x1="11.537"
          x2="43.662"
          y1="21.275"
          y2="56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2CECE" />
          <stop offset="1" stopColor="#97AAAA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10353_4636"
          x1="27.527"
          x2="27.527"
          y1="51.39"
          y2="46.598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2CECE" stopOpacity="0" />
          <stop offset="0.179" stopColor="#AFBCBC" stopOpacity="0.179" />
          <stop offset="1" stopColor="#5B6A6A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10353_4636"
          x1="7.431"
          x2="58.975"
          y1="28.012"
          y2="51.228"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A6F9" />
          <stop offset="1" stopColor="#0071E2" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10353_4636"
          x1="27.527"
          x2="27.527"
          y1="44.773"
          y2="47.654"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#008BF2" stopOpacity="0" />
          <stop offset="1" stopColor="#0046E2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10353_4636"
          x1="37.299"
          x2="4.644"
          y1="36.059"
          y2="3.404"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#008BF2" stopOpacity="0" />
          <stop offset="1" stopColor="#0046E2" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10353_4636"
          x1="24.091"
          x2="18.741"
          y1="42.526"
          y2="35.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2CECE" stopOpacity="0" />
          <stop offset="0.179" stopColor="#AFBCBC" stopOpacity="0.179" />
          <stop offset="1" stopColor="#5B6A6A" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10353_4636"
          x1="23.392"
          x2="23.392"
          y1="29.964"
          y2="13.525"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2CECE" stopOpacity="0" />
          <stop offset="0.179" stopColor="#AFBCBC" stopOpacity="0.179" />
          <stop offset="1" stopColor="#5B6A6A" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10353_4636"
          x1="37.035"
          x2="37.035"
          y1="29.964"
          y2="13.525"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2CECE" stopOpacity="0" />
          <stop offset="0.179" stopColor="#AFBCBC" stopOpacity="0.179" />
          <stop offset="1" stopColor="#5B6A6A" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10353_4636"
          x1="50.971"
          x2="39.949"
          y1="24.784"
          y2="27.665"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#008BF2" stopOpacity="0" />
          <stop offset="1" stopColor="#0046E2" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_10353_4636"
          x1="23.866"
          x2="19.596"
          y1="8.817"
          y2="4.548"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#008BF2" stopOpacity="0" />
          <stop offset="1" stopColor="#0046E2" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_10353_4636"
          x1="19.748"
          x2="19.748"
          y1="0.102"
          y2="23.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC200" />
          <stop offset="0.268" stopColor="#FB0" />
          <stop offset="0.659" stopColor="#FFA801" />
          <stop offset="1" stopColor="#FF9102" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_10353_4636"
          x1="20.072"
          x2="21.891"
          y1="3.743"
          y2="3.743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC200" stopOpacity="0" />
          <stop offset="0.203" stopColor="#FB0" stopOpacity="0.203" />
          <stop offset="0.499" stopColor="#FFA700" stopOpacity="0.499" />
          <stop offset="0.852" stopColor="#F80" stopOpacity="0.852" />
          <stop offset="1" stopColor="#FF7800" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_10353_4636"
          x1="38.523"
          x2="34.253"
          y1="8.817"
          y2="4.548"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#008BF2" stopOpacity="0" />
          <stop offset="1" stopColor="#0046E2" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_10353_4636"
          x1="34.405"
          x2="34.405"
          y1="0.102"
          y2="23.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC200" />
          <stop offset="0.268" stopColor="#FB0" />
          <stop offset="0.659" stopColor="#FFA801" />
          <stop offset="1" stopColor="#FF9102" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_10353_4636"
          x1="34.73"
          x2="36.548"
          y1="3.743"
          y2="3.743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC200" stopOpacity="0" />
          <stop offset="0.203" stopColor="#FB0" stopOpacity="0.203" />
          <stop offset="0.499" stopColor="#FFA700" stopOpacity="0.499" />
          <stop offset="0.852" stopColor="#F80" stopOpacity="0.852" />
          <stop offset="1" stopColor="#FF7800" />
        </linearGradient>
      </defs>
    </svg>
  );
}
